import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.discard_turn_off_modal')

const MODAL_Z_INDEX = 1200
const CONTENT_MAX_WIDTH = '520px'

export interface DiscardTurnOffModalProps {
  isOpen: boolean
  onDiscard: () => void
  onCancel: () => void
}

// Turn off after a local turn on drops the pending turn on and every edit made
// since. UnsavedChangesModal does not fit: its Publish would turn the brand on.
const DiscardTurnOffModal = ({
  isOpen,
  onDiscard,
  onCancel,
}: DiscardTurnOffModalProps) => {
  const [css] = useStyletron()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="auto"
      closeType="small"
      zIndex={MODAL_Z_INDEX}
      returnFocus={false}
    >
      <div
        className={`p-xl d-flex flex-column ${css({
          maxWidth: CONTENT_MAX_WIDTH,
        })}`}
      >
        <Text.Header3 tag="h3" className="m-0">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 color="grey70" className="mt-xs">
          {t('body')}
        </Text.BodyText3>
        <div className="d-flex justify-content-end mt-l">
          <Button kind={Kind.SECONDARY} className="mr-m" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button onClick={onDiscard}>{t('confirm')}</Button>
        </div>
      </div>
    </Modal>
  )
}

export default DiscardTurnOffModal
